import { AulaState } from '@core/types/state';

const changeConversationOpen = (
  state: AulaState['inboxv2'],
  action: { type: string; payload: boolean }
): AulaState['inboxv2'] => ({
  ...state,
  createConversationOpen: action.payload,
});

export default changeConversationOpen;
